import { take, put } from 'redux-saga/effects';
import { routeActions } from 'redux-simple-router';

import { VISIT_AND_UNITS } from '../constants/actionTypes';

export function *redirectTo404OnVisitNotFound() {
    while(true) {
        const {error} = yield take(VISIT_AND_UNITS.ERROR);
        if(error.response.status === 404) {
            yield put(routeActions.push('/notfound'));
        }
    }
}